import { memo } from "react";
import { useTopMedSchedule } from "../../../../../store/contexts/TopMedScheduleContext/TopMedScheduleContext";
import { ConfirmedMessage } from "../ConfirmedMessage/ConfirmedMessage";
import { IConfirmTopMedScheduleContainerProps } from "./models";

export const ConfirmTopMedScheduleContainer = memo(
  ({ children }: IConfirmTopMedScheduleContainerProps) => {
    const { registered } = useTopMedSchedule();

    if (registered) {
      return <ConfirmedMessage />;
    }

    return <>{children}</>;
  }
);
